<template>
  <article class="relative">
    <div
      class="
        bg-brand-orange
        absolute
        px-2
        flex
        items-center
        h-8
        -top-8
        rounded-t-md
        left-4
        w-[288px]
      "
    >
      <p v-if="timeslot" class="text-body text-white font-semibold">
        <!-- Start of Hardcoded timeslot for not fitting talks for 2023, to be removed after -->
        <span v-if="timeslot.start === '11:45'">
          11:45—13:50
        </span>
        <span v-else>
          {{ timeslot.start }}—{{ timeslot.end }}
        </span>
      </p>
    </div>

    <!-- Start of Hardcoded timeslot for not fitting talks for 2023, to be removed after -->
    <div v-if="timeslot.start === '11:45'">

      <ProgramCardMobileCard
        :timeslotSelections="timeslotSelections"
        @clicked="(e) => $emit('clicked', e)"
        :happening="timeslotHappenings.purple[0]"
        :shouldHaveRadio="true"
        :voting-opened="votingOpened"
        @update:timeslotSelections="
          (e) => $emit('update:timeslotSelections', e)
        "
      />

      <div
      v-for="(heurekaTalk, i) in timeslotHappenings.heureka"
      :key="heurekaTalk.id"
    >
      <ProgramCardMobileCard
        :voting-opened="votingOpened"
        :timeslotSelections="timeslotSelections"
        @clicked="(e) => $emit('clicked', e)"
        :happening="heurekaTalk"
        :shouldHaveRadio="true"
        @update:timeslotSelections="
          (e) => $emit('update:timeslotSelections', e)
        "
      />
    </div>

    <article class="relative">

<div
      class="
        bg-brand-orange
        absolute
        px-2
        flex
        items-center
        h-2
        -top-2
        left-4
        w-[288px]
      "
    ></div>
      <div
        class="
          bg-white
          rounded-md
          h-[80px]
          flex
          justify-between
          items-center
          relative
          shadow-md
          max-w-[340px]
          px-4
          mb-2
        "
      >
        <p class="text-big-body text-brand-gray-900 font-semibold">
          Oběd
        </p>

        <div
        class="
          bg-brand-green
          px-2
          flex
          items-center
           justify-center
          h-8
           ml-2
          rounded-md
          w-[258px]
        "
      >
        <p class="text-body text-white font-semibold">12:30—14:00</p>
      </div>
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.4766 5.97845C29.0791 5.98466 28.7003 6.14839 28.4235 6.43367C28.1466 6.71895 27.9943 7.10245 28 7.49994V17.4999C28 21.0933 30.6126 23.9758 34 24.6953V41.4999C33.9972 41.6987 34.0339 41.8961 34.108 42.0805C34.1822 42.265 34.2922 42.4328 34.4318 42.5744C34.5713 42.7159 34.7376 42.8284 34.921 42.9051C35.1044 42.9818 35.3012 43.0213 35.5 43.0213C35.6988 43.0213 35.8956 42.9818 36.079 42.9051C36.2624 42.8284 36.4287 42.7159 36.5682 42.5744C36.7078 42.4328 36.8178 42.265 36.892 42.0805C36.9661 41.8961 37.0028 41.6987 37 41.4999V24.6953C40.3874 23.9758 43 21.0933 43 17.4999V7.49994C43.0028 7.30117 42.9661 7.10383 42.892 6.91937C42.8178 6.73492 42.7078 6.56704 42.5682 6.42549C42.4287 6.28393 42.2624 6.17153 42.079 6.09481C41.8956 6.01808 41.6988 5.97858 41.5 5.97858C41.3012 5.97858 41.1044 6.01808 40.921 6.09481C40.7376 6.17153 40.5713 6.28393 40.4318 6.42549C40.2922 6.56704 40.1822 6.73492 40.108 6.91937C40.0339 7.10383 39.9972 7.30117 40 7.49994V17.4999C40 19.47 38.7468 21.0848 37 21.7011V7.49994C37.0028 7.30117 36.9661 7.10383 36.892 6.91937C36.8178 6.73492 36.7078 6.56704 36.5682 6.42549C36.4287 6.28393 36.2624 6.17153 36.079 6.09481C35.8956 6.01808 35.6988 5.97858 35.5 5.97858C35.3012 5.97858 35.1044 6.01808 34.921 6.09481C34.7376 6.17153 34.5713 6.28393 34.4318 6.42549C34.2922 6.56704 34.1822 6.73492 34.108 6.91937C34.0339 7.10383 33.9972 7.30117 34 7.49994V21.7011C32.2532 21.0848 31 19.47 31 17.4999V7.49994C31.0029 7.29917 30.9654 7.09987 30.8899 6.91385C30.8143 6.72782 30.7022 6.55886 30.5601 6.41698C30.418 6.27509 30.2489 6.16317 30.0628 6.08784C29.8767 6.01251 29.6773 5.97532 29.4766 5.97845ZM6.5 5.99994C6.10219 5.99998 5.72068 6.15803 5.43938 6.43932C5.15809 6.72062 5.00004 7.10213 5 7.49994V20.4999C5 25.1973 8.50828 28.946 13 29.6953V39.9999H9.5C9.30123 39.9971 9.10389 40.0339 8.91944 40.108C8.73498 40.1821 8.5671 40.2921 8.42555 40.4317C8.28399 40.5713 8.17159 40.7376 8.09487 40.921C8.01815 41.1043 7.97864 41.3012 7.97864 41.4999C7.97864 41.6987 8.01815 41.8955 8.09487 42.0789C8.17159 42.2623 8.28399 42.4286 8.42555 42.5682C8.5671 42.7077 8.73498 42.8178 8.91944 42.8919C9.10389 42.966 9.30123 43.0028 9.5 42.9999H14.2539C14.4149 43.0264 14.5792 43.0264 14.7402 42.9999H19.5C19.6988 43.0028 19.8961 42.966 20.0806 42.8919C20.265 42.8178 20.4329 42.7077 20.5745 42.5682C20.716 42.4286 20.8284 42.2623 20.9051 42.0789C20.9819 41.8955 21.0214 41.6987 21.0214 41.4999C21.0214 41.3012 20.9819 41.1043 20.9051 40.921C20.8284 40.7376 20.716 40.5713 20.5745 40.4317C20.4329 40.2921 20.265 40.1821 20.0806 40.108C19.8961 40.0339 19.6988 39.9971 19.5 39.9999H16V29.6953C20.4917 28.946 24 25.1973 24 20.4999V7.49994C24 7.10213 23.8419 6.72062 23.5606 6.43932C23.2793 6.15803 22.8978 5.99998 22.5 5.99994H6.5ZM8 8.99994H21V20.4999C21 24.0766 18.1504 26.9339 14.5859 26.9824C14.5287 26.9791 14.4713 26.9791 14.4141 26.9824C10.8496 26.9339 8 24.0766 8 20.4999V8.99994Z"
            fill="#A6C71F"
          />
        </svg>
      </div>
    </article>

      <ProgramCardMobileCard
        :timeslotSelections="timeslotSelections"
        @clicked="(e) => $emit('clicked', e)"
        :happening="timeslotHappenings.purple[1]"
        :shouldHaveRadio="false"
        :voting-opened="votingOpened"
        @update:timeslotSelections="
          (e) => $emit('update:timeslotSelections', e)
        "
      />


    </div>
    <!-- End Of Hardcoded timeslot for not fitting talks for 2023, to be removed after -->

    <div v-else>
      <div v-for="(purpleTalk, i) in timeslotHappenings.purple" :key="purpleTalk.id">
      <ProgramCardMobileCard
        :timeslotSelections="timeslotSelections"
        @clicked="(e) => $emit('clicked', e)"
        :happening="purpleTalk"
        :shouldHaveRadio="i === 0"
        :voting-opened="votingOpened"
        @update:timeslotSelections="
          (e) => $emit('update:timeslotSelections', e)
        "
      />
    </div>

    <div
      v-for="(heurekaTalk, i) in timeslotHappenings.heureka"
      :key="heurekaTalk.id"
    >
      <ProgramCardMobileCard
        :voting-opened="votingOpened"
        :timeslotSelections="timeslotSelections"
        @clicked="(e) => $emit('clicked', e)"
        :happening="heurekaTalk"
        :shouldHaveRadio="i === 0"
        @update:timeslotSelections="
          (e) => $emit('update:timeslotSelections', e)
        "
      />
    </div>
    </div>

  </article>
</template>
<script>
import ProgramCardMobileCard from "./ProgramCardMobileCard.vue";

export default {
  emits: ["update:timeslotSelections"],
  components: {
    ProgramCardMobileCard,
  },

  props: {
    timeslotHappenings: {
      type: [Object, Array],
    },
    timeslotSelections: {
      type: Object,
      default: undefined,
    },
    votingOpened: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    timeslot() {

      if(this.timeslotHappenings.heureka !== undefined) {

        if(this.timeslotHappenings.heureka.length > 1) {
          return this.timeslotHappenings.heureka[this.timeslotHappenings.heureka.length - 1];
        }
        return this.timeslotHappenings.heureka[0];

      } else {

        if(this.timeslotHappenings.purple.length > 1) {
          return this.timeslotHappenings.purple[this.timeslotHappenings.purple.length - 1];
        }

        return this.timeslotHappenings.purple[0];
      }
    },
  },
};
</script>

<style>
</style>
